import React, { useEffect, useMemo, useState } from 'react';
import '../../styles/Admin/admin_alumniDetail.css';
import moment from 'moment';
import ImageViewer from 'awesome-image-viewer';
import '../../styles/Admin/all.min.css';
import { useNavigate } from 'react-router-dom';
import { displaySnackbar, YesNoSelector } from '../../utilities';
import { BASE_URL } from '../../settings';

export default function AdminJobPostDetail({ job_post, fetchJobPosts }) {
    const [tab, setTab] = useState('Details');
    const [fetched_jobPost, setFetchedJobPost] = useState(job_post || {});
    let qualifications = [];
    if (fetched_jobPost?.qualifications)
        qualifications = JSON.parse(fetched_jobPost?.qualifications);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let pathname = location.pathname.split('/');
        let id = pathname[pathname.length - 1];

        fetch(`${BASE_URL}/jobs/read`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id }),
        })
            .then(async (result) => {
                let response = await result.json();
                let the_jobPost = response?.job_post;
                setFetchedJobPost(the_jobPost);
            })
            .catch((error) => {
                console.log(error?.message, '\n', error);
            });
    }, []);

    // handler to remove a job post
    // 👇️ handler to delete an event
    const deleteJobPost = (id) => {
        YesNoSelector('Are you sure you want to delete this job post?', (reply) => {
            if (reply === 'yes') {
                fetch(`${BASE_URL}/jobs/remove`, {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                })
                    .then(async (result) => {
                        let response = await result?.json();
                        if (response?.msg === null) {
                            displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                        } else {
                            console.log(response);
                            displaySnackbar(response?.msg, false, 'Ok', () => {});
                            setTimeout(() => {
                                fetchJobPosts();
                                navigate('/admin.console/jobposts');
                            }, 1000);
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                        } else {
                            displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                            console.log('the error:', error);
                        }
                    });
            }
        });
    };

    const images = useMemo(
        () => [
            {
                mainUrl: require('../../images/home.jpg'),
                thumbnailUrl: require('../../images/home.jpg'),
                description: 'Home',
            },
            {
                mainUrl: require('../../images/img1.jpg'),
                thumbnailUrl: require('../../images/img1.jpg'),
                description: 'Image 1',
            },
        ],
        []
    );

    return (
        <div className='alumni-detail'>
            {/* go back button */}
            <button onClick={() => navigate('/admin.console/jobposts')}>👈️ Go Back</button>

            {/* header bar */}
            <div className='alumni-detail-header-bar'>
                <div className='left'>
                    <h1>Job Post Detail</h1>
                </div>
                <div className='right'></div>
            </div>

            {/* job post content */}
            <div className='alumni-detail-main-content'>
                {tab === 'Details' ? (
                    <div className='details'>
                        <span className='details-sub-header'>Job Post Information</span>

                        <div className='details-content-item'>
                            <span className='title'>Actions</span>
                            <button
                                style={{ backgroundColor: 'orangered' }}
                                onClick={() => deleteJobPost(fetched_jobPost?.uuid)}
                            >
                                Delete this job post
                            </button>
                            <button
                                style={{ backgroundColor: 'green' }}
                                onClick={() =>
                                    navigate(
                                        `/admin.console/jobposts/edit/${fetched_jobPost?.uuid}`
                                    )
                                }
                            >
                                Edit this job post
                            </button>
                        </div>

                        <div className='details-content-item'>
                            <span className='title'>Details</span>
                            {fetched_jobPost?.details?.length > 0 ? (
                                <p className='text about'>{fetched_jobPost?.details}</p>
                            ) : (
                                <p className='empty-text'>...</p>
                            )}
                        </div>

                        <div className='details-content-items'>
                            <div className='details-content-item'>
                                <span className='title'>id</span>
                                {fetched_jobPost?.id > 0 ? (
                                    <p className='text'>{fetched_jobPost?.id}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>user id (uuid)</span>
                                {fetched_jobPost?.uuid?.length > 0 ? (
                                    <p className='text'>{fetched_jobPost?.uuid}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Company Email</span>
                                {fetched_jobPost?.email?.length > 0 ? (
                                    <p className='text'>{fetched_jobPost?.email}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Company name</span>
                                {fetched_jobPost?.companyName?.length > 0 ? (
                                    <p className='text'>{fetched_jobPost?.companyName}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Required position</span>
                                {fetched_jobPost?.positionName?.length > 0 ? (
                                    <p className='text'>{fetched_jobPost?.positionName}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Employees wanted</span>
                                {fetched_jobPost?.count?.length > 0 ? (
                                    <p className='text'>{fetched_jobPost?.count}</p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Redirect url</span>
                                {fetched_jobPost?.redirectUrl?.length > 0 ? (
                                    <p className='text'>
                                        <a href={fetched_jobPost?.redirectUrl}>
                                            {fetched_jobPost?.redirectUrl}
                                        </a>
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Qualifications</span>
                                {fetched_jobPost?.qualifications?.length > 0 ? (
                                    <ul className='qualifications-list'>
                                        {qualifications.map((item, index) => (
                                            <li
                                                key={`item?.uuid-#${index}`}
                                                className='qualifications-list-item'
                                            >
                                                {item?.name || `item-#${index}`}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Offer closes on</span>
                                {fetched_jobPost?.dueDate?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_jobPost?.dueDate)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Posted on</span>
                                {fetched_jobPost?.createdAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_jobPost?.createdAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>

                            <div className='details-content-item'>
                                <span className='title'>Last updated on</span>
                                {fetched_jobPost?.updatedAt?.length > 0 ? (
                                    <p className='text'>
                                        {moment(new Date(fetched_jobPost?.updatedAt)).calendar()}
                                    </p>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    <h1>Conversations</h1>
                )}
            </div>
        </div>
    );
}
